/**
 * A real 404.
 *
 * It names the two things that actually cause one — a mistyped address, or a
 * record that has since been removed — and offers the one route that is always
 * valid. There is no illustration and no apology: an operator who mistyped a
 * task id wants to get back to work, not to be commiserated with.
 */

import { Link } from 'react-router-dom'
import { Page, Panel, EmptyState, Button } from '@/components/primitives'
import { useT } from '@/i18n/context'

export function NotFoundPage() {
  const t = useT()

  return (
    <Page>
      <Panel>
        <EmptyState
          title={t('notfound.title')}
          hint={t('notfound.hint')}
          action={
            <Link to="/">
              <Button variant="primary">{t('notfound.home')}</Button>
            </Link>
          }
        />
      </Panel>
    </Page>
  )
}
